import { dispatchInputChangeEvent } from '../helpers';

const EMPTY_DATE_STRING = '00/00/0000';
const DAY_MAX_LENGTH = 2;
const MONTH_MAX_LENGTH = 2;
const YEAR_MAX_LENGTH = 4;

export default class JraDateOfBirth {
  constructor(element) {
    this.element = element;
    this.dobRegExp = new RegExp();
    this.initDateOfBirth();
  }

  initDateOfBirth() {
    this.dobHiddenInputField = this.element.querySelector('[data-jra-date-of-birth-hidden-input]');
    this.dayField = this.element.querySelector('[data-jra-date-of-birth-input="day"]');
    this.monthField = this.element.querySelector('[data-jra-date-of-birth-input="month"]');
    this.yearField = this.element.querySelector('[data-jra-date-of-birth-input="year"]');
    this.dobInputs = [...this.element.querySelectorAll('[data-jra-date-of-birth-input]')];
    this.dobInputs.forEach((input) => {
      input.addEventListener('change', () => this.updateDateOfBirth(input));
      input.addEventListener('keyup', () => this.updateDateOfBirth(input));
      input.addEventListener('click', () => this.onInputClick(input));
    });
  }

  // Force previous input focus when user selects an input but the previous ones are empty
  onInputClick = (input) => {
    if (input === this.monthField && input.value === '' && this.dayField.value.length < 2) {
      this.dayField.focus();
    } else if (input === this.yearField && input.value === '') {
      if (this.monthField.value.length < 2 && this.dayField.value.length < 2) {
        this.dayField.focus();
      } else if (this.monthField.value.length < 2 && this.dayField.value.length === 2) {
        this.monthField.focus();
      }
    }
  };

  // Hidden input has a default value of 00/00/0000.
  // Function will target the corresponding characters
  // (by index) for day/month/year and update them
  updateDateOfBirth = (input) => {
    // Workaround fix, closed sections have their values cleared.
    if (this.dobHiddenInputField.value === '') {
      this.dobHiddenInputField.value = EMPTY_DATE_STRING;
    }
    // Prevent a blank string being passed
    if (input.value.length > 0) {
      let newValue = '';
      if (input.dataset.jraDateOfBirthInput === 'day') {
        // custom maxlength handling for devices/browsers that don't support maxlength attribute
        if (input.value.length > DAY_MAX_LENGTH) {
          input.value = input.value.substring(0, DAY_MAX_LENGTH);
        }

        if (input.value.length > 1) {
          newValue = input.value + this.dobHiddenInputField.value.substring(2);
          this.dobHiddenInputField.value = newValue;
          dispatchInputChangeEvent(this.dobHiddenInputField);
          // Tab to the next field automatically
          this.monthField.focus();
        } else {
          newValue = '0' + input.value + this.dobHiddenInputField.value.substring(2);
          this.dobHiddenInputField.value = newValue;
          dispatchInputChangeEvent(this.dobHiddenInputField);
        }
      } else if (input.dataset.jraDateOfBirthInput === 'month') {
        // custom maxlength handling for devices/browsers that don't support maxlength attribute
        if (input.value.length > MONTH_MAX_LENGTH) {
          input.value = input.value.substring(0, MONTH_MAX_LENGTH);
        }

        if (input.value.length > 1) {
          newValue =
            this.dobHiddenInputField.value.substring(0, 3) +
            input.value +
            this.dobHiddenInputField.value.substring(5);
          this.dobHiddenInputField.value = newValue;
          dispatchInputChangeEvent(this.dobHiddenInputField);
          this.yearField.focus();
        } else {
          newValue =
            this.dobHiddenInputField.value.substring(0, 3) +
            '0' +
            input.value +
            this.dobHiddenInputField.value.substring(5);
          this.dobHiddenInputField.value = newValue;
          dispatchInputChangeEvent(this.dobHiddenInputField);
        }
      } else if (input.dataset.jraDateOfBirthInput === 'year') {
        // custom maxlength handling for devices/browsers that don't support maxlength attribute
        if (input.value.length > YEAR_MAX_LENGTH) {
          input.value = input.value.substring(0, YEAR_MAX_LENGTH);
        }

        newValue = this.dobHiddenInputField.value.substring(0, 6) + input.value;
        this.dobHiddenInputField.value = newValue;
        dispatchInputChangeEvent(this.dobHiddenInputField);
      }
    }
    // If blank string is sent
    else {
      if (input.dataset.jraDateOfBirthInput === 'day') {
        this.dobHiddenInputField.value = '00' + this.dobHiddenInputField.value.substring(2);
        dispatchInputChangeEvent(this.dobHiddenInputField);
      } else if (input.dataset.jraDateOfBirthInput === 'month') {
        this.dobHiddenInputField.value =
          this.dobHiddenInputField.value.substring(0, 3) +
          '00' +
          this.dobHiddenInputField.value.substring(5);
        dispatchInputChangeEvent(this.dobHiddenInputField);
      } else if (input.dataset.jraDateOfBirthInput === 'year') {
        this.dobHiddenInputField.value = this.dobHiddenInputField.value.substring(0, 6) + '0000';
        dispatchInputChangeEvent(this.dobHiddenInputField);
      }
    }
  };
}
